// This icon file is generated automatically.
var PShakeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M4.06 9.4a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm9.64-4.83L9.43.3a1.03 1.03 0 00-1.45 0L.3 7.98c-.4.4-.4 1.05 0 1.45l4.27 4.27a1.02 1.02 0 001.45 0l7.68-7.68c.4-.4.4-1.05 0-1.45zm-8.4 8.18L1.25 8.7 8.7 1.25l4.05 4.05-7.45 7.45zM1.39 4.84c.05.05.12.05.17 0l3.28-3.28a.12.12 0 000-.17l-.6-.6a.12.12 0 00-.18 0L.8 4.06a.12.12 0 000 .18l.6.6zm11.23 4.32a.12.12 0 00-.18 0l-3.28 3.28a.12.12 0 000 .17l.6.6c.05.05.13.05.18 0l3.27-3.27a.12.12 0 000-.18l-.6-.6z", "fill-rule": "nonzero" } }] }, "name": "p-shake", "theme": "outlined" };
export default PShakeOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PShakeOutlined.js
// module id = 3622
// module chunks = 0